// extracted by mini-css-extract-plugin
module.exports = {"expand-description-content":"expand-description-content_expand-description-content__VnQ1W"};